import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function Terms({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('terms_title')}</h1>

      <p>{t('terms_intro')}</p>

      <h2>{t('terms_h2_use')}</h2>
      <ul>
        <li>{t('terms_use_item1')}</li>
        <li>{t('terms_use_item2')}</li>
        <li>{t('terms_use_item3')}</li>
      </ul>

      <h2>{t('terms_h2_content')}</h2>
      <p>{t('terms_content_p1')}</p>

      <h2>{t('terms_h2_services')}</h2>
      <p>{t('terms_services_p1')}</p>

      <h2>{t('terms_h2_changes')}</h2>
      <p>{t('terms_changes_p1')}</p>

      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}

export default Terms;

